import React from 'react';

const lazyLoaderStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
  fontSize: '14px',
  color: '#666',
};

const LazyLoader: React.FC = () => (
  <div style={lazyLoaderStyle} role="status" aria-live="polite" aria-label="Loading content">
    Loading...
  </div>
);

export default LazyLoader;
